angular.module("Main").controller("ForgotPasswordController", ["$rootScope", "$scope", "$location", "$state",
    "$cookies", "$uibModal", "$uibModalInstance", "AuthenticationService", "BookingService", "DialogService",
    function ($rootScope, $scope, $location, $state, $cookies, $uibModal, $uibModalInstance, AuthenticationService, BookingService, DialogService) {
        var vm = this;

        vm.dataForm = {};

        BookingService.loadLayoutConfiguration().then(function (data) {
            vm.layoutSettings = angular.fromJson(data.Layout);
            vm.registrierungZulassen = data.RegistrierungZulassen;
        });


        let forgotPassword = false;
        vm.forgotPassword = function (forgot) {
            vm.lockedEmail = false;
            vm.dataForm.email.$setTouched();
            vm.errorText = "";

            if (vm.dataForm.$valid) {
                if (!forgotPassword) {
                    forgotPassword = true;
                    vm.dataLoading = true;
                    BookingService.checkEmailForLogin(forgot.email).then(function (data) {
                        if (data.IsLocked) {
                            vm.lockedEmail = true;
                            forgotPassword = false;
                            vm.dataLoading = false;
                        } else if (!_.isEmpty(data.uid)) {
                            AuthenticationService.getNewPassword(data.uid).then(function () {
                                forgotPassword = false;
                                vm.dataLoading = false;
                                vm.newPasswordSend = true;
                                vm.infoText = "LT_Es_wurde_ein_neues_password_geschickt";
                            }).catch(function (err) {
                                forgotPassword = false;
                                vm.dataLoading = false;
                                vm.errorHeader = "T_Fehler";
                                vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten";
                            });
                        } else {
                            forgotPassword = false;
                            vm.dataLoading = false;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Die_email_existiert_nicht_in_unserem_system";
                        }
                    }).catch(function (err) {
                        if (err.status === 409) {
                            forgotPassword = false;
                            vm.dataLoading = false;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Email_mehrfach_vorhanden";
                        } else {
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten";
                        }
                    })
                }
            }
        };

        vm.registerModal = function () {
            $uibModalInstance.close();
            DialogService.openRegisterDialog().catch(function () { });
        };
    }]);